export interface InvalidValidationResult{
    [key: string]: any;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
